import { HammerModule } from '@angular/platform-browser'
import { NgModule, LOCALE_ID, APP_INITIALIZER } from '@angular/core'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { PhdSoftCommonModule, PhdsoftMessageService } from '@phdsoft/common'
import { ServiceWorkerModule } from '@angular/service-worker'
import { AppRoutingModule } from './app-routing.module'
import { AppComponent } from './app.component'
import { AppService } from './app.service'
import { StoreModule } from '@ngrx/store'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { MatTooltipModule } from '@angular/material/tooltip'
import { MatSelectModule } from '@angular/material/select'
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'
import { AutomaticPointsModule } from './automatic-points/collection-inspection-gaugins-positioning-wizard.module'
import { DragDropModule } from '@angular/cdk/drag-drop'
import { MultiSelectModule } from 'primeng/multiselect'
import { MAT_DATE_LOCALE } from '@angular/material/core'
import { DialogModule } from 'primeng/dialog'
import { MenuModule } from 'primeng/menu'
import { ScrollingModule } from '@angular/cdk/scrolling';
import { TableModule } from 'primeng/table';
import { QuillModule } from 'ngx-quill';
import { NavigationLifecycleCoordinatorService } from './shared/lifecycle/navigation-lifecycle-coordinator.service'
import { LogUpdateService } from './shared/services/service-worker/log-update.service'
import { PromptUpdateService } from './shared/services/service-worker/prompt-update.service'
import { HandleUnrecoverableStateService } from './shared/services/service-worker/handle-unrecoverable-state.service'
import { CheckForUpdateService } from './shared/services/service-worker/check-for-update.service'
import { environment } from 'src/environments/environment'
import { HTTP_INTERCEPTORS } from '@angular/common/http'
import { LoadingInterceptor } from './shared/interceptors/loading.interceptor'
import { ChecklistDatesInterceptor } from './shared/interceptors/checklist-dates.interceptor'
import { loadingReducer } from './shared/store/ui/ui.reducer'
import { NgxExtendedPdfViewerModule, pdfDefaultOptions } from 'ngx-extended-pdf-viewer'

@NgModule({
  declarations: [AppComponent],
  imports: [
    TableModule,
    DialogModule,
    MultiSelectModule,
    AppRoutingModule,
    BrowserAnimationsModule, // already includes BrowserModule
    MatSelectModule,
    MatProgressSpinnerModule,
    PhdSoftCommonModule,
    StoreModule.forRoot({ loading: loadingReducer }),
    HammerModule,
    FormsModule,
    MenuModule,
    ReactiveFormsModule,
    MatTooltipModule,
    AutomaticPointsModule,
    DragDropModule,
    ScrollingModule,
    ReactiveFormsModule,
    QuillModule.forRoot(),
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.enableServiceWorker,
      registrationStrategy: 'registerImmediately'
    }),
    NgxExtendedPdfViewerModule,
  ],
  providers: [
    AppService,
    PhdsoftMessageService,
    { provide: MAT_DATE_LOCALE, useValue: 'en-US' },
    { provide: LOCALE_ID, useValue: 'en-US' },
    { provide: HTTP_INTERCEPTORS, useClass: LoadingInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ChecklistDatesInterceptor, multi: true },
    {
      provide: APP_INITIALIZER,
      useFactory: (
        // DO NOT REMOVE. We are instantiating the services!
        navigationCoordinator: NavigationLifecycleCoordinatorService,
        logUpdateService: LogUpdateService,
        promptUpdateService: PromptUpdateService,
        handleUnrecoverableStateService: HandleUnrecoverableStateService,
        checkForUpdateService: CheckForUpdateService
      ) => () => {
        // Configure PDF viewer assets folder based on environment
        // pdfDefaultOptions.assetsFolder = environment.PDF_ASSETS_FOLDER;
        // The service is instantiated before app bootstrap
      },
      deps: [
        NavigationLifecycleCoordinatorService,
        LogUpdateService,
        PromptUpdateService,
        HandleUnrecoverableStateService,
        CheckForUpdateService
      ],
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})

export class AppModule { }
